<template>
  <div class="dashboard">
    <Dashboard /> 
    <div class="container">
      <router-view/>
    </div>
  </div>
</template>

<script>
  import Dashboard from '@/components/Dashboard/index'
  
  export default {
    name: "dashboard",
    data: () => ({
      nav_title: 'User Dashboard'
    }),
    components: {
     Dashboard
    }
  }
</script>